import React from 'react';
import { clientsForUser } from '../utils/clients';

// Wrappable pill capsules for the clients a person is assigned to (each
// showing their client-specific role, if any) — shared between the
// self-view Profile page and the admin's per-teammate profile popup so both
// render this identically. Caller supplies its own section heading; this
// only renders the capsule row (or the empty-state line).
export default function ClientCapsules({ uuid, clientStaff, clients }) {
  const assigned = clientsForUser(uuid, clientStaff, clients);

  if (assigned.length === 0) {
    return <p className="text-sm text-muted">Not assigned to any clients yet.</p>;
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {assigned.map((c) => (
        <span
          key={c.client_id}
          className="inline-flex items-center rounded-full font-medium px-2.5 py-1 text-xs bg-light-gold text-bronze"
        >
          {c.name}
          {c.role && <span className="text-muted ml-1">· {c.role}</span>}
        </span>
      ))}
    </div>
  );
}
